<template>
  <div class="RankingWrap">
    <div class="RankingTit">
      <div class="item">
        <span v-for="(item, index) in RankingTit" :key="index" :class="{ 'ac': index === RankingListIndex }"
          @click="idindex(index)">{{ item }}</span>
      </div>
      <div class="btn" @click="goOther">更多 ></div>

    </div>
    <div class="RankingList" v-if="RankingList[RankingListIndex].data.length">
      <div class="Listtit">
        <span v-for="(item, index) in RankingList[RankingListIndex].tit" :key="index">{{ item }}</span>
      </div>
      <div class="ListItem">
        <p v-for="(item, index) in RankingList[RankingListIndex].data" :key="index">
          <span>
            <img v-if="item.field1 == 1" :src="require('@/assets/imgs/rank/' + 0 + '.png')" alt="">
            <img v-else-if="item.field1 == 2" :src="require('@/assets/imgs/rank/' + 1 + '.png')" alt="">
            <img v-else-if="item.field1 == 3" :src="require('@/assets/imgs/rank/' + 2 + '.png')" alt="">
            <template v-else>
              {{ item.field1 }}
            </template>
          </span>
          <span>{{ item.field2 }}</span>
          <span>{{ item.field3 }} </span>
          <!-- <span>{{ item.field4 }}</span> -->
        </p>

      </div>
    </div>
    <div v-else class="RankingList_NO">
      <img src="@/assets/imgs/home/noData.png" alt="">
    </div>
  </div>
</template>

<script>
import { getWebRankList } from '@/api/rank/index.js'//排行榜Api

export default {
  name: 'ranking',
  // props:{
  //   title:'',
  //   isMore:false,
  //   tit2:[],
  //   type:'',
  // },
  data() {
    return {
      RankingTit: ['充值排行', 'VIP排行', '天梯排行', '成就排行'],
      RankingList: [
        {
          tit: ['排名', '账号', '本周充值'],
          data: []
        },
        {
          tit: ['排名', '账号', '累计获取积分'],
          data: []
        },
        {
          tit: [],
          data: []
        },
        {
          tit: [],
          data: []
        }
      ],
      RankingListIndex: 0,

    }
  },
  created() {
    this.getRankData(1); // 排行
  },
  components: {
  },

  methods: {
    // goOther(){
    //   this.$router.push({
    //     name:this.type
    //   })
    // },
    idindex(index) {
      // console.log(index);
      // this.$message.info('敬请期待')
      this.RankingListIndex = index
      this.getRankData(index + 1)
    },
    goOther() {
      this.$router.push({
        name: 'Rank'
      })
    },

    /* 游戏排行相关*/
    async getRankData(type) {
      // let data = {
      //   type: type,
      // };
      await getWebRankList({
        type: type
      }).then((res) => {
        if (res.data.state == 200) {
          if (res.data.data.rankOneList) {
            this.RankingList[this.RankingListIndex].data = res.data.data.rankOneList.splice(0, 10);
          }
        } else {
          this.$message.error(res.data.message);
        }
      })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
}
</script>

<style lang="less" scoped>
.RankingWrap {
  width: 95%;
  height: 87%;
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);

  .RankingTit {
    .item {
      display: flex;
      justify-content: space-evenly;
      // margin-top: 10px;
      padding: 10px;


      span {
        font-size: 22px;
        font-weight: 700;
        cursor: pointer;
      }

      .ac {
        color: #6C3F00;
      }
    }

    .btn {
      position: absolute;
      right: 50px;
      top: 10px;
      width: 50px;
      min-width: 50px;
      height: 18px;
      line-height: 18px;
      text-align: center;
      color: #ffffff;
      font-size: 12px;
      border-radius: 20px;
      cursor: pointer;
      background: #6C3F00;
    }

  }

  .RankingList {
    .Listtit {
      display: flex;
      justify-content: space-around;
      border-bottom: 1px dashed #ffffff;
      border-top: 1px dashed #ffffff;
      padding: 10px 0;
      background: #734E00;

      span {
        flex: 1;
        color: #ffffff;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
      }

    }

    .ListItem {
      p {
        display: flex;
        justify-content: space-around;
        padding: 11px 0;
        border-bottom: 1px dashed #ffffff;

        span {
          flex: 1;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }

      p:last-child {
        border: none;
      }

      p:nth-of-type(-n + 3) {
        padding: 5px 0;
      }
    }


  }

  .RankingList_NO {
    height: 80%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
